// extracted by mini-css-extract-plugin
module.exports = {"container":"GalleryCard_container__f4qqR","thumbnail":"GalleryCard_thumbnail__sMhZg","title":"GalleryCard_title__90hVP"};